import { render, staticRenderFns } from "./OrderFail.vue?vue&type=template&id=2704eea5&scoped=true&"
import script from "./OrderFail.vue?vue&type=script&lang=js&"
export * from "./OrderFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2704eea5",
  null
  
)

export default component.exports